module.exports = __webpack_public_path__ + "img/status-change.a09133d6.png";